import {Object3D} from "three";
import {disposeContent} from "./dispose-content";
import {nodeTraverse} from "./node-traverse";

export function dispose3dResource<T extends Object3D<any>>(...objects: T[]){

    //Depth first algorithm to remove childs systematically
    const clearChildren = (obj: T) => {
        if(obj.children.length === 0) { return; }
        if(obj.children.length > 0){
            obj.children.forEach( (node) =>  clearChildren(node as T) )
        }
        obj.clear();
    }

    objects.forEach(node => {
        node?.parent?.remove(node);
        node.traverse(disposeContent) //scene graph changes are discouraged in traverse function
        clearChildren(node);
    })

}